theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.parentNode.appendChild(subMenuToggle);
        });


      });
      
      /* global.js's trapFocus takes its last boundary straight from
         getFocusableElements, which matches on selectors alone. The drawer's
         language switch keeps its two collapsed options in the DOM at
         `visibility: hidden`, so that boundary is an element the browser will
         never focus, the wrap never fires, and Tab walks out of an open drawer
         into the page behind it. Filter to what can actually take focus. */
      const focusableInDrawer = function () {
        return getFocusableElements(offcanvasHeader).filter(function (el) {
          const cs = window.getComputedStyle(el);
          return (
            cs.visibility !== "hidden" &&
            cs.display !== "none" &&
            el.getClientRects().length > 0
          );
        });
      };

      /* Open/Close Menu On Click Toggle Button */
      const drawerIsOpen = function () {
        return offcanvasHeader.classList.contains("open");
      };

      const openDrawer = function () {
        offcanvasHeader.classList.add("open");
        offcanvasOpen.setAttribute("aria-expanded", "true");
        body.style.overflowY = "hidden";
        /* The drawer is `visibility: collapse` until `.open` lands, and a
           collapsed element cannot take focus, so trapFocus's focus() call is
           dropped and the keyboard user opens a menu they are still standing
           outside of. Reading a layout property forces the style flush that
           makes it focusable. A requestAnimationFrame would do the same, but
           only in a tab the browser is painting: this has to hold anywhere. */
        var flush = offcanvasHeader.offsetWidth;
        if (flush >= 0) offcanvasHeader.focus();
      };

      /* returnFocus only when the drawer was dismissed deliberately. An outside
         click or a resize should not yank the caret back up to the header. */
      const closeDrawer = function (returnFocus) {
        if (!drawerIsOpen()) return;
        offcanvasHeader.classList.remove("open");
        offcanvasOpen.setAttribute("aria-expanded", "false");
        body.style.overflowY = null;
        if (returnFocus) offcanvasOpen.focus();
      };

      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        if (drawerIsOpen()) {
          closeDrawer(false);
        } else {
          openDrawer();
        }
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        closeDrawer(true);
      });

      /* Escape is the expected way out of a drawer. Without it the only exit a
         keyboard user has is finding the close control by tabbing. */
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" && event.code !== "Escape") return;
        closeDrawer(true);
      });

      /* Keep Tab inside the open drawer. The page behind it is still in the
         tab order and still scrolled under a locked body, so escaping it puts
         the caret somewhere the user cannot see. */
      document.addEventListener("keydown", function (event) {
        if (!drawerIsOpen()) return;
        if (event.key !== "Tab" && event.code !== "Tab") return;
        const els = focusableInDrawer();
        if (els.length === 0) return;
        const first = els[0];
        const last = els[els.length - 1];
        const active = document.activeElement;
        if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        } else if (
          event.shiftKey &&
          (active === first || active === offcanvasHeader)
        ) {
          event.preventDefault();
          last.focus();
        } else if (!offcanvasHeader.contains(active)) {
          /* Focus already sits outside — a browser control, or a stray
             programmatic focus. Pull it back to the top of the drawer. */
          event.preventDefault();
          first.focus();
        }
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            closeDrawer(false);
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          closeDrawer(false);
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
